export function trackEvent(event, parameters = {}) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event,
    ...parameters,
  });
}

export function trackEcommerce(event, ecommerce) {
  window.dataLayer = window.dataLayer || [];

  // Prevent previous ecommerce values leaking into this event.
  window.dataLayer.push({
    ecommerce: null,
  });

  window.dataLayer.push({
    event,
    ecommerce,
  });
}